// Saved-build persistence for the turnkey configurator.
//
// CLIENT-ONLY, by design and by necessity. The server writes no Set-Cookie on a
// rendered page and the HTML micro-cache is keyed by pathname alone, so the SSR
// output must be identical for every visitor (INSTRUCTIONS §3/§4). This cookie is
// therefore written only on user action and read only AFTER mount — never during
// render, which would make the client's first tree differ from the SSR HTML.
//
// It holds selection IDs only: itemTypes, option ids, the wizard answers. No
// prices (those always come from the live offers, so a stale cookie can never
// resurrect an old price) and nothing personal beyond the first name the wizard
// asked for.

export const COOKIE_NAME = 'vrs_turnkey_build'
const MAX_AGE_DAYS = 30
// Cookies are capped around 4 KB per cookie. A build is a few hundred bytes, so
// this only ever trips if something upstream starts stuffing the payload — in
// which case dropping the write is better than emitting a corrupt cookie.
const MAX_BYTES = 3500

const isBrowser = () => typeof document !== 'undefined'

export function readSavedBuild() {
  if (!isBrowser()) return null
  try {
    const match = document.cookie.split('; ').find((c) => c.startsWith(`${COOKIE_NAME}=`))
    if (!match) return null
    const raw = decodeURIComponent(match.slice(COOKIE_NAME.length + 1))
    const parsed = JSON.parse(raw)
    if (!parsed || typeof parsed !== 'object') return null
    return parsed
  } catch (e) {
    // A malformed cookie must never break the page — fall back to a fresh build.
    return null
  }
}

export function writeSavedBuild(state) {
  if (!isBrowser()) return
  try {
    const value = encodeURIComponent(JSON.stringify(state))
    if (value.length > MAX_BYTES) return
    const expires = new Date(Date.now() + MAX_AGE_DAYS * 864e5).toUTCString()
    document.cookie = `${COOKIE_NAME}=${value}; path=/; expires=${expires}; SameSite=Lax`
  } catch (e) {
    /* storage disabled or full — the configurator still works, it just won't persist */
  }
}

export function clearSavedBuild() {
  if (!isBrowser()) return
  document.cookie = `${COOKIE_NAME}=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT; SameSite=Lax`
}
